import { withModal, confirmModal } from '@tls/ui-modal';

import { ModalNames } from './enum';

export default withModal(confirmModal, ModalNames.SHARED_PERMISSION_MODAL);
